import loginMainImg from '../Auth/assets/loginMainImage.webp';
import loginMainImgMobile from '../Auth/assets/loginMainImage-mobile.webp';

export const loginMainImage = loginMainImg;
export const loginMainImageMobile = loginMainImgMobile;

function getLoginMainImagesToPreload() {
    if (typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches) {
        return [loginMainImgMobile];
    }

    return [loginMainImg];
}

function preloadImage(src, signal) {
    return new Promise((resolve) => {
        if (signal?.aborted) {
            resolve(null);
            return;
        }

        const img = new Image();

        const finish = () => {
            signal?.removeEventListener('abort', onAbort);
            resolve(src);
        };

        const onAbort = () => finish();

        signal?.addEventListener('abort', onAbort, { once: true });
        img.onload = finish;
        img.onerror = finish;
        img.src = src;
    });
}

export async function preloadLoginImages({ signal } = {}) {
    if (typeof window === 'undefined') {
        return { imagesReady: false };
    }

    await Promise.all(
        getLoginMainImagesToPreload().map((src) => preloadImage(src, signal)),
    );

    return { imagesReady: true };
}
